module.exports = __webpack_public_path__ + "static/media/f_hairstyle_straight_medium_back_vector.8bca5a2b.svg";